import type { MinutesOrdering } from "@repo/types";
import { Button } from "@repo/ui/components/Base/Button";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/Base/Dialog";
import { useState } from "react";
import { MinutesOrderingDropdown } from "./MinutesOrderingDropdown";

export interface MeetingGenerateMinutesConfirmData {
  minutesOrdering: MinutesOrdering;
}

export interface MeetingGenerateMinutesDialogProps {
  minutesOrdering?: MinutesOrdering;
  onConfirm?: (data: MeetingGenerateMinutesConfirmData) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
  className?: string;
}

export const MeetingGenerateMinutesDialog = ({
  minutesOrdering: defaultMinutesOrdering = "timestamps",
  onConfirm,
  open,
  setOpen,
  className,
}: MeetingGenerateMinutesDialogProps) => {
  const [minutesOrdering, setMinutesOrdering] = useState(
    defaultMinutesOrdering
  );

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className={className}>
        <DialogHeader>
          <DialogTitle>Confirm Generate Minutes</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="my-2">
            You are about to generate meeting minutes. Once the meeting minutes
            are both generated and saved, the meeting can no longer be run. Are
            you sure you want to continue?
          </div>
          <MinutesOrderingDropdown
            label="Ordering for minutes"
            value={minutesOrdering}
            onValueChange={setMinutesOrdering}
          />
        </DialogBody>
        <DialogFooter className="justify-between">
          <Button variant="destructive" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <div className="flex-1" />
          <Button
            variant="default"
            onClick={() => {
              onConfirm?.({ minutesOrdering });
              setOpen(false);
            }}
          >
            Continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
